import gql from 'graphql-tag'
import client from '@stores/apollo'
import { Order, TicketStatus } from '@api/types'
import { TicketConnectionWithTotal, TicketKeyValueFilter } from './types'
import { TicketFragment } from '@api/fragments'

interface Variables {
  after: string | null
  query: string
  sortBy: string
  order: Order
  status: TicketStatus | null
  keyValueFilters: TicketKeyValueFilter[]
  first: number
}

interface Payload {
  data: {
    viewer: {
      company: {
        tickets: TicketConnectionWithTotal
      }
    }
  }
}

export default function list(variables: Variables): Promise<TicketConnectionWithTotal> {
  return client.gql.query({ query: ticketQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { tickets },
        },
      },
    }: Payload) => tickets
  )
}

export const ticketQuery = gql`
  query Tickets(
    $after: String
    $sortBy: TicketSortBy
    $order: TicketOrder
    $status: TicketStatusEnum
    $query: String
    $keyValueFilters: [TicketKeyValueFiltersInput]
    $first: Int
  ) {
    viewer {
      company {
        tickets(
          first: $first
          status: $status
          after: $after
          sortBy: $sortBy
          order: $order
          query: $query
          keyValueFilters: $keyValueFilters
        ) {
          counters {
            tickets
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...TicketFragment
            }
          }
        }
      }
    }
  }
  ${TicketFragment}
`
